/* eslint-disable @typescript-eslint/no-explicit-any */
import { oc } from 'ts-optchain';

import { DateTimeFormatter } from 'js-joda';
import { adjustForBusinessDay } from 'utils/timeUtils';
import { core } from '@tock/coretypes';
import { isEmpty, map, toNumber, toString, trim } from 'es-toolkit/compat';
import AppConstants from 'constants/AppConstants';
import protos from 'utils/protos';

const { Waitlist } = protos;

function itemToProto(item: any) {
  const proto = Waitlist.fromObject({
    id: (oc(item) as any).id(),
  });

  const isTimeRangeRequest = item.startTime && item.endTime;

  proto.desiredDate = Array.isArray(item.requestedDate)
    ? map(item.requestedDate, (date) => toString(date))
    : [toString(item.requestedDate)];

  if (isTimeRangeRequest) {
    proto.desiredDateTimeRange = proto.desiredDate.map((dateString: string) => {
      const startDateTime = adjustForBusinessDay(dateString, item.startTime).format(
        DateTimeFormatter.ISO_LOCAL_DATE_TIME
      );

      const endDateTime = adjustForBusinessDay(dateString, item.endTime).format(
        DateTimeFormatter.ISO_LOCAL_DATE_TIME
      );

      return { startDateTime, endDateTime };
    });
    proto.desiredDate = [];
  }

  const numCustomers = toNumber(item.numCustomers);
  if (!Number.isNaN(numCustomers)) {
    proto.desiredSize = numCustomers;
  }
  const experienceId = toNumber(item.experience);
  if (!Number.isNaN(experienceId)) {
    proto.ticketTypeId = experienceId;
  }
  proto.firstName = item.firstName;
  proto.lastName = item.lastName;
  proto.email = item.email;
  if (!isEmpty(item.phoneNumber)) {
    proto.phone = item.phoneNumber;
  }
  if (!isEmpty(item.note)) {
    proto.note = item.note;
  }

  if (!isEmpty(trim(item.desiredService))) {
    proto.desiredService = toNumber(item.desiredService);
  }

  proto.phoneCountryCode = item.phoneCountryCode;
  proto.isoCountryCode = item.isoCountryCode;

  return proto;
}

/**
 * @deprecated use addNotifyEntry instead
 */
export function addWaitlistEntry(item: any): ApiAction {
  const proto = itemToProto(item);
  return {
    TockApi: {
      postProto: '/waitlist',
      request: proto,
      toast: 'Waitlist entry added',
      type: AppConstants.REPORT_WAITLISTS_ADD_ITEM,
    },
  };
}

export function addNotifyEntry(item: core.IWaitlist): ApiAction {
  const request = itemToProto(item);
  return {
    TockApi: {
      postProto: '/waitlist',
      request: request,
      toast: 'Notify list entry added',
      type: AppConstants.REPORT_WAITLISTS_ADD_ITEM,
    },
  };
}

/**
 * @deprecated use editNotifyEntry instead
 */
export function editWaitlistEntry(item: any): ApiAction {
  const proto = itemToProto(item);

  return {
    TockApi: {
      putProto: '/waitlist',
      request: proto,
      toast: 'Waitlist entry updated',
      type: AppConstants.REPORT_WAITLISTS_EDIT_ITEM,
    },
  };
}

export function editNotifyEntry(item: core.IWaitlist): ApiAction {
  const request = itemToProto(item);
  return {
    TockApi: {
      putProto: '/waitlist',
      request: request,
      toast: 'Notify list entry updated',
      type: AppConstants.REPORT_WAITLISTS_EDIT_ITEM,
    },
  };
}

export function deleteNotifyEntry(id: number): ApiAction {
  return {
    TockApi: {
      deleteProto: `/waitlist/${id}`,
      type: AppConstants.REPORT_WAITLISTS_DELETE_ITEM,
      toast: 'Notify list entry deleted',
    },
  };
}
